(() => {
    document.addEventListener("DOMContentLoaded", function () {

        const $get = id => document.getElementById(id);

        const newTable = $get("mainTable");

        const tJsonW = $get("JSONRoadType") as HTMLTextAreaElement; 
        let roadTypes = JSON.parse(tJsonW.value);

        const tJsonTitle = $get("JSONTitle") as HTMLTextAreaElement;
        const titleData = JSON.parse(tJsonTitle.value);

        const tJson = $get("JSONData") as HTMLTextAreaElement;
        const compactionData = tJson.value;
        
        const allData = JSON.parse(compactionData);

        const container = $get("mainTable");

        let innerHTML = `
            
            <div class="row align-items-left mt-1" style="text-indent: 0px">
                <div class="col mt-2 w-auto" style="line-height:1.7em">
                    <label for="">Select road type(s):</label><br />
                
                        `;

        let cb = 0;
        roadTypes.forEach((x) => {
            innerHTML += `<label for="ww${cb}"><input style="margin-left: 45px; margin-right:10px" type="checkbox" name="ww${cb}" id="ww${cb}" class="lValue" value="${x}" /><b>${x}</b></label><br />`
            cb += 1;
        }
        );

        innerHTML += `
                    
               </div>
            </div>
            <div class="row mt-2" style="text-indent: 0px">
                <div class="form-group col-lg-7 mt-1">
                    <button id="btnShowRequirements"
                                name="command"
                                value="search"
                                type="submit"
                                class="ml-1  btn btn-primary">
                            Show requirements
                    </button>

                </div>
           </div>

            <div id="tblRequirements" class="mt-1"></div>
        `

        container.innerHTML = innerHTML;


        const btnShowRequirementsClick = function (event) {

            const dataRow = allData[0];

            const lValues: string[] = [];

            $("input:checkbox[class=lValue]:checked").each(function () {
                lValues.push(String($(this).val()));
            });

            const invalidSelection = lValues.length === 0;

            if (!invalidSelection) {

                let block1 = lValues.indexOf('Flexible & composite roads - S6') > -1;
                let block2 = lValues.indexOf('Rigid & modular roads - S7') > -1;
                let block3 = lValues.indexOf('Footways, footpaths & cycle tracks - S8') > -1;

                let txt = `
<style>

table.table-sroh td {
    border-left: 1px solid #000;
    border-right: 1px solid #000;
}



table.table-sroh th {
    border-left: 1px solid #000;
    border-right: 1px solid #000;
    border-bottom: 1px solid #000;
    border-top: 1px solid #000;
}




table.table-sroh caption {
    font-weight: bold;
    font-size: 1.2em;
    caption-side: top;
}


table.table-sroh tr.border-bottom, table.table-sroh td.border-bottom {
    border-bottom: 1px solid #000 !important;
}

table.table-sroh tr.shaded, table.table-sroh td.shaded, table.table-sroh th.shaded {
 background-color: #E5EEFD;
}


table.table-sroh td.notapp {
 background-color: #f0f0f0;
}


tr.partition td,  tr.partition th {
    border-top: 2px solid black;
}

td, th {
    text-align: center;
}

th.secondrow {
    font-weight: normal;
}

</style>
        <table role="table" class="table table-responsive table-sroh mt-2" style="margin-left:0em">
        <caption>${titleData.Title}</caption>
            <thead>
            <tr>
                <th class="shaded" rowspan="3" style="width:14%; vertical-align:top">Reinstatement method<br />(at first visit)</th>`


                if (block1 == true) {
                    txt += `
                    <th class="shaded" colspan = "2" style="vertical-align:top">Flexible & composite roads<br /><br />S6</th>`
                }

                if (block2 == true) {
                    txt += `
                    <th class="shaded" colspan = "4" style="vertical-align:top">Rigid & modular roads<br /><br />S7</th>`
                }

                if (block3 == true) {
                    txt += `
                    <th class="shaded" colspan = "3" style="vertical-align:top">Footways, footpaths & cycle tracks<br /><br />S8</th>`
                }

                txt += `

            </tr>
            <tr>`

                if (block1 == true) {
                    txt += `
                    <th class="secondrow" rowspan = "2" style="vertical-align:top">Flexible<br /><br />(A3.0 - A3.4 incl.)</th>
                    <th class="secondrow" rowspan = "2" style="vertical-align:top">Composite<br /><br />(A4.0 - A4.3 incl.)</th>`
                }

                if (block2 == true) {
                    txt += `
                    <th class="secondrow" rowspan = "2" style="vertical-align:top">Rigid<br /><br />(A5.0 - A5.2 incl.)</th>
                    <th class="secondrow" colspan = "3" style="vertical-align:top">Modular</th>`
                }

                if (block3 == true) {
                    txt += `
                    <th class="secondrow" rowspan = "2" style="vertical-align:top">Flexible and<br />composite<br />(A7.1 and A7.2)</th>
                    <th class="secondrow" rowspan = "2" style="vertical-align:top">Rigid<br /><br />(A7.3)</th>
                    <th class="secondrow" rowspan = "2" style="vertical-align:top">Modular<br /><br />(A7.4)</th>`
                }

                txt += `</tr><tr>`

                if (block2 == true) {
                    txt += `
                    <th class="secondrow" style="vertical-align:top">Bituminous base (roadbase)<br /><br />(A6.1)</th>
                    <th class="secondrow" style="vertical-align:top">Composite base (roadbase)<br /><br />(A6.2)</th>
                    <th class="secondrow" style="vertical-align:top">Granular base (roadbase)<br /><br />(A6.3)</th>
                    `
                }

                txt += `
            </tr>
            </thead>
            <tbody>`
           
                txt += processTableBlock("All permanent", dataRow.AllPerm, block1, block2, block3);
                txt += processTableBlock("Interim with permanent binder course", dataRow.InterimCourse, block1, block2, block3);
                txt += processTableBlock("Interim with permanent base", dataRow.InterimBase, block1, block2, block3);
                txt += processTableBlock("Interim with permanent sub-base", dataRow.InterimSubBase, block1, block2, block3);
                txt += processTableBlock("Permanent incorporating interim surface overlay", dataRow.Permanent, block1, block2, block3);

                txt += `</tbody>

           

            
            </table>
            `;

               // render the table... 

                $get("tblRequirements").innerHTML = txt;

            }
            else {
                $get("tblRequirements").innerHTML = "";
            }
        };


        const processTableBlock = function (label, dataItem, block1, block2, block3) {
            let txt = `<tr class="border-bottom">
            <th>${label}</th>`

            if (block1 == true) {
                txt += `<td class="${calc_class(dataItem.find(i => i.key === 'Flexible & composite roads - S6').value[0])}">${dataItem.find(i => i.key === 'Flexible & composite roads - S6').value[0]}</td>`
                txt += `<td class="${calc_class(dataItem.find(i => i.key === 'Flexible & composite roads - S6').value[1])}">${dataItem.find(i => i.key === 'Flexible & composite roads - S6').value[1]}</td>`
            }

            if (block2 == true) {
                txt += `<td class="${calc_class(dataItem.find(i => i.key === 'Rigid & modular roads - S7').value[0])}">${dataItem.find(i => i.key === 'Rigid & modular roads - S7').value[0]}</td>`
                txt += `<td class="${calc_class(dataItem.find(i => i.key === 'Rigid & modular roads - S7').value[1])}">${dataItem.find(i => i.key === 'Rigid & modular roads - S7').value[1]}</td>`
                txt += `<td class="${calc_class(dataItem.find(i => i.key === 'Rigid & modular roads - S7').value[2])}">${dataItem.find(i => i.key === 'Rigid & modular roads - S7').value[2]}</td>`
                txt += `<td class="${calc_class(dataItem.find(i => i.key === 'Rigid & modular roads - S7').value[3])}">${dataItem.find(i => i.key === 'Rigid & modular roads - S7').value[3]}</td>`
            }

            if (block3 == true) {
                txt += `<td class="${calc_class(dataItem.find(i => i.key === 'Footways, footpaths & cycle tracks - S8').value[0])}">${dataItem.find(i => i.key === 'Footways, footpaths & cycle tracks - S8').value[0]}</td>`
                txt += `<td class="${calc_class(dataItem.find(i => i.key === 'Footways, footpaths & cycle tracks - S8').value[1])}">${dataItem.find(i => i.key === 'Footways, footpaths & cycle tracks - S8').value[1]}</td>`
                txt += `<td class="${calc_class(dataItem.find(i => i.key === 'Footways, footpaths & cycle tracks - S8').value[2])}">${dataItem.find(i => i.key === 'Footways, footpaths & cycle tracks - S8').value[2]}</td>`
            }

            txt += `</tr>`


            return txt;
        }

        const calc_class = function (value) {
            if(value == 'N/A')
                return "notapp";
            else
                return "";
        }

        $get("btnShowRequirements").addEventListener("click", btnShowRequirementsClick);

    });

})();
